import React, { Component } from 'react'
import { VideoCount } from '../videoCount/index'
import { Link } from 'react-router-dom'
import './_fullmenu.scss'

class FullMenu extends Component {
  render() {
    const { videos } = this.props
    const intimacy = <span>The <b>Intimacy</b></span>
    const legacy = <span>Builds <b className="Legacy">Legacy</b></span>

    return (
      <div className="FullMenu">
        <div className="inner">
          {videos.map((video, i) => (
            <div className="menu_listing" key={`menu_listing_${i}`}>
              <VideoCount active={i} videos={videos} />
              <div className="video_title">
                <h4 className={`${video.title}`}>
                  {video.title === 'The Intimacy'  ? intimacy : video.title}
                   <span className={`description ${video.description}`}> {video.description === 'Builds Legacy' ? legacy : video.description} </span>
                  <Link to={`/${video.slug}`}>
                    <span className="cta"> ({video.cta})</span>
                  </Link>
                </h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default FullMenu



// WEBPACK FOOTER //
// ./src/components/fullMenu/index.js